import React from 'react'
import { useSelector } from 'react-redux'

import { Box, Typography } from '@material-ui/core'

import { selectSelectedTariffName } from '../../store/tariff.selectors'

import { RootState } from '~/core/store/root.reducer'
import ModifyButton from '~/ui/components/ModifyButton/ModifyButton'

export default function TariffSummary({ id }: { id: string }) {
  const tariffName = useSelector((state: RootState) => selectSelectedTariffName(state, id))
  return (
    <Box>
      <Typography variant="subtitle1">TARIFA SELECCIONADA</Typography>
      <Box display="flex" flexDirection="row" alignItems="baseline" mt={5} mb={4}>
        <Typography variant="body2">Tarifa: </Typography>
        <Box ml={1}>
          <Typography variant="subtitle2" data-hook={`${id}.tariffName`}>
            {tariffName}
          </Typography>
        </Box>
      </Box>
      <ModifyButton text="Modificar Tarifa" />
    </Box>
  )
}
